import { render, staticRenderFns } from "./CustomerInvoiceDetails.vue?vue&type=template&id=3787ee89&scoped=true"
import script from "./CustomerInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceDetails.vue?vue&type=style&index=0&id=3787ee89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787ee89",
  null
  
)

export default component.exports